import styled from 'styled-components';
import Button from 'components/Button';
import { PURPLE_500, PURPLE_600, WHITE } from '../../../constants';

export const StyledButton = styled(Button)`
    color: ${PURPLE_500};
    height: auto;
    min-height: unset;
    padding: 0;
    font-size: 0.8125rem;
    line-height: 1rem;
    font-weight: 400;
    background: transparent;
    box-shadow: none;
    flex-shrink: 0;

    &:hover,
    &:focus,
    &:active {
        color: ${PURPLE_600};
        background: transparent;
        box-shadow: none;
    }
`;

export const DropDown = styled.div`
    display: flex;
    width: max-content;
    max-width: calc(100vw - 2rem);
    padding: 0.75rem 0 1.5rem;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 1rem;
    background: ${WHITE};
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.06), 0px 8px 24px 0px rgba(75, 70, 92, 0.16);
`;

export const Header = styled.div`
    width: 100%;
    padding: 0 1rem 0.75rem 1.5rem;
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.625rem;
`;

export const PriceTableContainer = styled.div`
    margin: 0 1rem 0 1.5rem;
    border: 1px solid #E5E7EB;
    border-radius: 8px;
    overflow-x: auto;
`;

export const Table = styled.table`
    width: max-content;
    min-width: 100%;
    border-collapse: collapse;
    font-size: 13px;
`;

export const TableRow = styled.tr`
    border-bottom: 1px solid #E5E7EB;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background-color: #F9FAFB;
    }
`;

export const TableHeader = styled.th`
    text-align: left;
    padding: 10px 16px;
    color: #6B7280;
    font-weight: 500;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    background-color: #F9FAFB;
    white-space: nowrap;
`;

export const TableTotalRow = styled(TableRow)`
    font-weight: 600;
    background-color: #F9FAFB;

    &:hover {
        background-color: #F9FAFB;
    }
`;

export const TableCell = styled.td`
    padding: 10px 16px;
    color: #111827;
    white-space: nowrap;
`;
